module.exports = __webpack_public_path__ + "media/images/icons8-salute-7784781c1cf717e03754db0cbbb142d9.svg";